/**
 * FikoDxf — B-Rep kenarlarını 2D DXF'e (R12 ASCII) dönüştürür.
 * Model occt_edgeGroups (dünya koord polyline) → görünüm düzlemine projekte → LINE entity'leri.
 * Lazer/plazma/su jeti/CAM/dokümantasyon için evrensel format.
 */

export type DxfGorunum = 'ust' | 'on' | 'yan';

interface P3 { x: number; y: number; z: number; }

/** Bir 3D noktayı seçili görünüme (2D) projekte eder. */
function projekte(p: P3, g: DxfGorunum): { x: number; y: number } {
  if (g === 'on') return { x: p.x, y: p.z };
  if (g === 'yan') return { x: p.y, y: p.z };
  return { x: p.x, y: p.y };   // üst
}

/** edgeGroups ({pts:[{x,y,z}]}) → DXF metni. Her polyline segmenti bir LINE. */
export function edgelerToDxf(edgeGroups: any[], gorunum: DxfGorunum = 'ust'): { dxf: string; cizgiSayisi: number } {
  const L: string[] = [];
  const push = (kod: number, deger: string | number) => { L.push(String(kod)); L.push(String(deger)); };
  push(0, 'SECTION'); push(2, 'ENTITIES');
  let cizgi = 0;
  for (const grup of edgeGroups || []) {
    const pts: P3[] = grup?.pts; if (!Array.isArray(pts) || pts.length < 2) continue;
    for (let i = 1; i < pts.length; i++) {
      const a = projekte(pts[i - 1], gorunum), b = projekte(pts[i], gorunum);
      if (Math.abs(a.x - b.x) < 1e-6 && Math.abs(a.y - b.y) < 1e-6) continue;
      push(0, 'LINE'); push(8, '0');
      push(10, a.x.toFixed(4)); push(20, a.y.toFixed(4)); push(30, '0.0');
      push(11, b.x.toFixed(4)); push(21, b.y.toFixed(4)); push(31, '0.0');
      cizgi++;
    }
  }
  push(0, 'ENDSEC'); push(0, 'EOF');
  return { dxf: L.join('\n'), cizgiSayisi: cizgi };
}

/** DXF metnini .dxf dosyası olarak indir. */
export function dxfIndir(dxf: string, dosyaAd = 'fikoyt-parca.dxf'): void {
  const blob = new Blob([dxf], { type: 'application/dxf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a'); a.href = url; a.download = dosyaAd; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
